import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from 'sweetalert2';
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    post: [],
  },
  getters: {
    Post(state) {
      return state.post;
    },
  },
  mutations: {
    llenarPost(state, data) {
      state.post = data;
    },
  },
  actions: {
    async getAttributesTable({ commit }) {
      let d = await axios.get("PuestoData/ListadoPuesto");
      commit("llenarPost", d.data);
      console.log(d.data)
    },

     registrarPuesto({ dispatch }, parametro) {

       axios.post("PuestoData/Registrar", parametro).then(r=>{
        console.log(r.data)
        if(r.data.estado){
             Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Se Registro  Correctamente',
        showConfirmButton: false,
        timer: 1500
      })
      dispatch("getAttributesTable");
        }
     
       });
      
    },

    modificarPuesto({ dispatch }, respuesta) {

      Swal.fire({
        title: '¿Eliminar Registro?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText:'No',
        confirmButtonText: 'Si'
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("¡Eliminado!", "El registro ha sido eliminado con éxito.", "success");

           axios.put("PuestoData/Modificar/", respuesta).then(r =>{
            console.log(r.data)
              if(r.data){
                dispatch("getAttributesTable")

              }
           });

        }
      })

    },
  },
  modules: {},
};
